import {lazy} from "react";

export const ReportMileageSummaryLazy = lazy(() => import('./ReportMileageSummary'))